export const LOCALES = {
  'en-US': {
    en: 'en',
    fr: 'fr',
    english: 'English',
    french: 'French'
  },
  'fr': {
    en: 'en',
    fr: 'fr',
    english: 'Anglais',
    french: 'Francais'
  }
};

export function normalizeLocale(locale) {
  if (!locale) {
    locale = 'en-US';
  } else {
    if (locale.indexOf('en') !== -1) {
      locale = 'en-US';
    } else if (locale.indexOf('fr') !== -1) {
      locale = 'fr';
    } else {
      locale = 'en-US';
    }
  }

  return locale;
}
